
import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./ViewSentApplication.css";
import Footer from "./components/Footer";
import Header from "./components/Header";


const params = new URLSearchParams(window.location.search);
const isEmail = params.get('source') === 'email';

const API_BASE_URL = isEmail
  ? 'http://127.0.0.1:5000'          // Puppeteer on server → localhost
  : 'http://180.211.162.102:5000'; 

const ViewSentApplication = () => {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const navigate = useNavigate();

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [deletingId, setDeletingId] = useState(null);
  const [viewingTempInstitute, setViewingTempInstitute] = useState(false);

  // Check if user is admin on component mount
  useEffect(() => {
    const auth = JSON.parse(localStorage.getItem("auth"));
    if (!auth?.isAdmin) {
      // If not admin, redirect to appropriate page
      if (auth?.role === "Institute") {
        navigate("/simApp");
      } else {
        navigate("/");
      }
    }
  }, [navigate]);

  // Fetch applications from backend
  const fetchApplications = async () => {
    try {
      setLoading(true);
      setError("");

      const response = await axios.get(`${API_BASE_URL}/applications`);
      console.log("API Response:", response.data);

      setApplications(
        Array.isArray(response.data)
          ? response.data
          : response.data.data || []
      );
    } catch (err) {
      console.error("Error fetching applications:", err);
      setError(err.response?.data?.message || err.message);

      if (err.response?.status === 401) {
        handleLogout();
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchApplications();
    const interval = setInterval(() => {
      fetchApplications();
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  const handleLogout = () => {
    // Clear all auth-related data
    localStorage.removeItem("auth");
    localStorage.removeItem("instituteData");
    localStorage.removeItem("currentView");
    localStorage.removeItem("tempInstituteData");
    localStorage.removeItem("isAdminViewingTemp");
    navigate("/");
  };
    const refreshApplications = () => {
    fetchApplications();
  };

  const getApplicationType = (type) => {
    const types = {
      new_sim: "নতুন ইআইআইএন সিম উত্তোলন",
      eiin_sim_replacement: "পুরাতন ইআইআইএন সিম রিপ্লেসমেন্ট",
      lost_sim_reissue: "হারানো সিম উত্তোলন",
    };
    return types[type] || type;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    try {
      return new Date(dateString).toLocaleString("bn-BD", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch (error) {
      return dateString;
    }
  };

  const deleteApplication = async (id, index) => {
    if (!window.confirm("আপনি কি এই আবেদনটি মুছে ফেলতে চান?")) {
      return;
    }

    try {
      setDeletingId(id);
      
      const response = await axios.delete(`${API_BASE_URL}/applicationsDelete/${id}`);
      
      if (response.data.success) {
        setApplications(applications.filter((app) => app.sl_no !== id));
        alert("আবেদন সফলভাবে মুছে ফেলা হয়েছে");
      } else {
        alert(response.data.message || "আবেদন মুছতে ব্যর্থ হয়েছে 1");
      }
    } catch (err) {
      console.error("Error deleting application:", err);
      alert(err.response?.data?.message || "আবেদন মুছতে ব্যর্থ হয়েছে 2");
    } finally {
      setDeletingId(null);
    }
  };

  const viewApplicationDetails = async (application) => {
    try {
      const auth = JSON.parse(localStorage.getItem("auth"));
      
      // Check if admin is viewing another institute
      if (auth?.isAdmin && application.inst_code && application.inst_code !== auth.loggedInInstCode) {
        try {
          // Fetch the target institute's data
          const response = await fetch(`${API_BASE_URL}/institute-info?inst_code=${encodeURIComponent(application.inst_code)}`);
          const result = await response.json();
          
          if (result.success) {
            // Remove password from the fetched data
            const { PASSWORD, ...instituteData } = result.data;
            
            // Store temporary institute data
            localStorage.setItem("tempInstituteData", JSON.stringify(instituteData));
            localStorage.setItem("isAdminViewingTemp", "true");
            setViewingTempInstitute(true);
            
            console.log(`Admin temporarily viewing: ${instituteData.INST_NAME}`);
          }
        } catch (error) {
          console.error("Failed to fetch institute data:", error);
        }
      } else {
        // If admin viewing own or same institute, use regular data
        localStorage.removeItem("tempInstituteData");
        localStorage.removeItem("isAdminViewingTemp");
        setViewingTempInstitute(false);
      }
      
      navigate(`/print/${application.sl_no}`);
      
    } catch (error) {
      console.error("Error opening PDF:", error);
      navigate(`/print/${application.sl_no}`);
    }
  };

  const restoreAdminView = () => {
    // When admin goes back to viewing their own data
    localStorage.removeItem("tempInstituteData");
    localStorage.removeItem("isAdminViewingTemp");
    setViewingTempInstitute(false);
    console.log("Restored admin view");
  };

  // Filter applications based on search term and status
  const filteredApplications = applications.filter((app) => {
    const matchesSearch =
      app.applicant_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      app.inst_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      app.inst_code?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      app.contact_number?.includes(searchTerm);

    const matchesStatus = !filterStatus || app.status === filterStatus;

    return matchesSearch && matchesStatus;
  });

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentApplications = filteredApplications.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredApplications.length / itemsPerPage);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Go to next page
  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  // Go to previous page
  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Handle items per page change
  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  // Add a button in your JSX to restore admin view if viewing temporary institute
  const renderRestoreButton = () => {
    if (viewingTempInstitute) {
      return (
        <button 
          onClick={restoreAdminView}
          style={{
            marginLeft: '10px',
            padding: '8px 16px',
            backgroundColor: '#ff9800',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          ← Back to Admin View
        </button>
      );
    }
    return null;
  };

  return (
    <>
      <Header />
      <div>
        <div className="container">
          <div className="form-box">
            <h3>সকল জমা দেয়া আবেদন ({filteredApplications.length})</h3>

            {/* Search and Filter Controls */}
            <div className="controls-container" style={{ marginBottom: '20px' }}>
              <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '15px' }}>
                <input
                  type="text"
                  placeholder="সার্চ করুন..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{
                    padding: '8px 12px',
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    minWidth: '200px'
                  }}
                />
                <button
                  onClick={refreshApplications}
                  className="btn btn-green"
                  style={{ padding: '8px 16px' }}
                >
                  রিফ্রেশ
                </button>
              </div>

              {/* Items per page selector */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <label>প্রতি পৃষ্ঠায়:</label>
                <select
                  value={itemsPerPage}
                  onChange={handleItemsPerPageChange}
                  style={{
                    padding: '4px 8px',
                    border: '1px solid #ddd',
                    borderRadius: '4px'
                  }}
                >
                  <option value={5}>৫</option>
                  <option value={10}>১০</option>
                  <option value={20}>২০</option>
                  <option value={50}>৫০</option>
                </select>
              </div>
            </div>

            {loading ? (
              <div className="loading">লোড হচ্ছে...</div>
            ) : filteredApplications.length === 0 ? (
              <div className="no-data">
                <p>কোন আবেদন পাওয়া যায়নি</p>
                <button
                  onClick={() => navigate("/application-form")}
                  className="btn btn-green"
                >
                  নতুন আবেদন করুন
                </button>
              </div>
            ) : (
              <>
                <div className="applications-table-container">
                  <table className="applications-table">
                    <thead>
                      <tr>
                        <th>ক্রমিক নং</th>
                        <th>আবেদনকারীর নাম</th>
                        <th>প্রতিষ্ঠানের নাম</th>
                        <th>আবেদনের বিষয়</th>
                        <th>যোগাযোগ নম্বর</th>
                        <th>মোবাইল</th>
                        <th>Action</th>
                        <th>পিডিএফ</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentApplications.map((app, index) => (
                        <tr key={app.sl_no || index}>
                          <td>{indexOfFirstItem + index + 1}</td>
                          <td>{app.applicant_name}</td>
                          <td>{app.inst_code || "N/A"}</td>
                          <td>{getApplicationType(app.application_subject)}</td>
                          <td>{app.contact_number}</td>
                          <td>{app.mobile_no}</td>
                          <td>
                            <button
                              onClick={() => deleteApplication(app.sl_no, index)}  // Change from _id to sl_no
                              className="btn-delete"
                              disabled={deletingId === app.sl_no}  // Change from _id to sl_no
                              style={{
                                backgroundColor: deletingId === app.sl_no ? '#ccc' : '#dc3545',  // Change from _id to sl_no
                                color: 'white',
                                border: 'none',
                                padding: '6px 12px',
                                borderRadius: '4px',
                                cursor: deletingId === app.sl_no ? 'not-allowed' : 'pointer',  // Change from _id to sl_no
                                fontSize: '13px',
                                minWidth: '70px'
                              }}
                            >
                              {deletingId === app.sl_no ? 'Deleting...' : 'Delete'}  
                            </button>
                          </td>
                          <td>
                            <button
                              onClick={() => viewApplicationDetails(app)}
                              className="btn-view"
                            >
                              পিডিএফ
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Pagination Controls */}
                <div className="pagination-container" style={{
                  marginTop: '20px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  gap: '10px'
                }}>
                  <div style={{ color: '#666' }}>
                    দেখানো হচ্ছে {indexOfFirstItem + 1} থেকে {Math.min(indexOfLastItem, filteredApplications.length)} এর মধ্যে {filteredApplications.length} টি আবেদন
                  </div>
                  
                  <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <button
                      onClick={prevPage}
                      disabled={currentPage === 1}
                      style={{
                        padding: '6px 12px',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        backgroundColor: currentPage === 1 ? '#f5f5f5' : 'white',
                        cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                        opacity: currentPage === 1 ? 0.6 : 1
                      }}
                    >
                      পূর্ববর্তী
                    </button>
                    
                    {/* Page numbers */}
                    <div style={{ display: 'flex', gap: '5px' }}>
                      {Array.from({ length: totalPages }, (_, i) => i + 1)
                        .filter(page => {
                          // Show only some pages around current page for better UX
                          if (totalPages <= 7) return true;
                          if (page === 1 || page === totalPages) return true;
                          if (Math.abs(page - currentPage) <= 2) return true;
                          return false;
                        })
                        .map((page, index, array) => {
                          // Add ellipsis for skipped pages
                          const prevPage = array[index - 1];
                          if (prevPage && page - prevPage > 1) {
                            return (
                              <React.Fragment key={`ellipsis-${page}`}>
                                <span style={{ padding: '0 5px' }}>...</span>
                                <button
                                  onClick={() => paginate(page)}
                                  style={{
                                    padding: '6px 12px',
                                    border: currentPage === page ? '1px solid #007bff' : '1px solid #ddd',
                                    borderRadius: '4px',
                                    backgroundColor: currentPage === page ? '#007bff' : 'white',
                                    color: currentPage === page ? 'white' : '#333',
                                    cursor: 'pointer'
                                  }}
                                >
                                  {page}
                                </button>
                              </React.Fragment>
                            );
                          }
                          return (
                            <button
                              key={page}
                              onClick={() => paginate(page)}
                              style={{
                                padding: '6px 12px',
                                border: currentPage === page ? '1px solid #007bff' : '1px solid #ddd',
                                borderRadius: '4px',
                                backgroundColor: currentPage === page ? '#007bff' : 'white',
                                color: currentPage === page ? 'white' : '#333',
                                cursor: 'pointer'
                              }}
                            >
                              {page}
                            </button>
                          );
                        })}
                    </div>
                    
                    <button
                      onClick={nextPage}
                      disabled={currentPage === totalPages}
                      style={{
                        padding: '6px 12px',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        backgroundColor: currentPage === totalPages ? '#f5f5f5' : 'white',
                        cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                        opacity: currentPage === totalPages ? 0.6 : 1
                      }}
                    >
                      পরবর্তী
                    </button>
                  </div>

                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span>পৃষ্ঠা:</span>
                    <select
                      value={currentPage}
                      onChange={(e) => paginate(Number(e.target.value))}
                      style={{
                        padding: '4px 8px',
                        border: '1px solid #ddd',
                        borderRadius: '4px'
                      }}
                    >
                      {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                        <option key={page} value={page}>
                          {page}
                        </option>
                      ))}
                    </select>
                    <span>/{totalPages}</span>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ViewSentApplication;